/**
 * Number formatting utilities for Indian numbering system
 */

/**
 * Format number in Indian format (##,##,###)
 * @param {number|string} value - The number to format
 * @returns {string} Formatted number with Indian commas
 */
export function formatIndianNumber(value) {
  if (value === null || value === undefined || value === '') return '0';
  
  const num = Number(value);
  if (isNaN(num)) return '0';
  
  return num.toLocaleString('en-IN');
}

/**
 * Format currency in Indian Rupees
 * @param {number|string} value - The amount to format
 * @returns {string} Formatted currency with ₹ symbol
 */
export function formatIndianCurrency(value) {
  if (value === null || value === undefined || value === '') return '₹0.00';
  
  const num = Number(value);
  if (isNaN(num)) return '₹0.00';
  
  return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Format currency rate (per SMS) in Indian Rupees with full precision
 * Shows minimum 4 decimal places, up to 6 — never rounds rates
 * @param {number|string} value - The rate to format
 * @returns {string} Formatted rate with ₹ symbol and full precision
 */
export function formatIndianRate(value) {
  if (value === null || value === undefined || value === '') return '₹0.0000';
  
  const num = Number(value);
  if (isNaN(num)) return '₹0.0000';
  
  // Determine actual significant decimals (up to 6)
  const str = num.toFixed(6).replace(/0+$/, '').replace(/\.$/, '');
  const decimals = str.includes('.') ? str.split('.')[1].length : 0;
  const minDec = Math.max(decimals, 4);
  
  return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: minDec, maximumFractionDigits: 6 });
}

/**
 * Format number with decimal places in Indian format
 * @param {number|string} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number with Indian commas and decimals
 */
export function formatIndianNumberWithDecimals(value, decimals = 2) {
  if (value === null || value === undefined || value === '') return '0';
  
  const num = Number(value);
  if (isNaN(num)) return '0';
  
  return num.toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}
